import React, { useState } from 'react';
import { Container, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Toolbar, Typography } from '@mui/material';
import { lighten } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import FileCopyIcon from '@mui/icons-material/FileCopy';

import useFetchList from '../../hooks/FetchList';
import ListHeader from '../../components/ListHeader';
import produce from 'immer';

const fields = [
  { id: 'version', numeric: false, disablePadding: true, label: 'Version' },
  { id: 'desc', label: 'Description' },
  { id: 'draft', label: 'DRAFT' },
  { id: 'actions', label: 'Actions' },
];

const useToolbarStyles = makeStyles()((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const TableToolbar = (props) => {
  const { classes } = useToolbarStyles();

  return (
    <Toolbar className={classes.root}>
      <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
        Label Templates
      </Typography>
    </Toolbar>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function ListTemplate() {
  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    order_by: 'id',
    desc: true,
  });
  const data = useFetchList('/templates', filter);
  const { page, size, desc, order_by } = filter;
  const { items, total } = data;

  const navigate = useNavigate();

  const { classes } = useStyles();
  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;

    setFilter(
      produce(filter, (draft) => {
        draft.desc = !isDesc;
        draft.page = 0;
        draft.order_by = property;
      }),
    );
  };

  const handleChangePage = (event, newPage) => {
    setFilter(
      produce(filter, (draft) => {
        draft.page = newPage;
      }),
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter(
      produce(filter, (draft) => {
        draft.page = 0;
        draft.size = parseInt(event.target.value, 10);
      }),
    );
  };

  const copy = (item) => (e) => {
    navigate(`/templates/${item.version}/clone`);
  };

  if (!items || items.length === 0) return <div>Loading...</div>;

  return (
    <Container maxWidth={false}>
      <Paper className={classes.paper}>
        <TableToolbar />
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={items.length} />
            <TableBody>
              {items.map((item, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow hover tabIndex={-1} key={item.version}>
                    <TableCell id={labelId} scope="row">
                      {item.version}
                    </TableCell>
                    <TableCell>{item.desc}</TableCell>
                    <TableCell>{!!item.draft ? 'true' : 'false'}</TableCell>
                    <TableCell width={150}>
                      <IconButton onClick={copy(item)} aria-label="clone label" size="large">
                        <FileCopyIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20, 30]}
          component="div"
          count={total}
          rowsPerPage={size}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
}
